import { render } from "./DepartmentListWidget.vue?vue&type=template&id=0d587b40&scoped=true&ts=true"
import script from "./DepartmentListWidget.vue?vue&type=script&lang=ts"
export * from "./DepartmentListWidget.vue?vue&type=script&lang=ts"

import "./DepartmentListWidget.vue?vue&type=style&index=0&id=0d587b40&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d587b40"]])

export default __exports__